import { UPDATE_AUTO_PAY_REQUEST, UPDATE_AUTO_PAY_FAILURE, UPDATE_AUTO_PAY_SUCCESS } from '../constants/autoPay';
import { DeepReadonly } from 'utility-types';
import { AxiosError } from 'axios';
import { Actions } from '../actions/autoPay';

export type State = DeepReadonly<{
  isFetching: boolean;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case UPDATE_AUTO_PAY_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case UPDATE_AUTO_PAY_SUCCESS:
      return {
        isFetching: false,
        error: null
      };
    case UPDATE_AUTO_PAY_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
